import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sweetgreen/garnish';

import type { LocationResultsProps } from '../../LocationScreen.types';
import {
  LocationAutocompleteInput,
  LocationSearchInput,
} from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const SearchBar = (props: LocationResultsProps): React.ReactElement => {
  const {
    locationSearchTypePicker,
    locationSearchType,
    predictionsData,
    customerAddresses,
  } = props;

  // should auto focus input on delivery search with no predictions and addresses.
  const isDelivery = locationSearchType === 'delivery';
  const noPredictions = (predictionsData?.predictions?.length ?? 0) === 0;
  const noAddresses = (customerAddresses?.length ?? 0) === 0;
  const isEmptyDeliverySearch = isDelivery && noPredictions && noAddresses;

  const { minWidth } = useResponsive();

  // - Search input for 'Pickup' and 'Outpost'
  // - Search input with autocomplete for 'Delivery'
  const searchInputType =
    locationSearchType === 'delivery' ? 'autocomplete' : 'search';

  // ─── STYLES ──────────────────────────────────────────────────────

  const wrapperStyles = [
    styles.wrapper,
    minWidth.tablet ? styles.wrapperSM : {},
  ];
  const searchInputWrapperStyle = [
    styles.searchInputWrapper,
    minWidth.tablet ? styles.searchInputWrapperSM : {},
  ];

  // ─────────────────────────────────────────────────────────────────

  return (
    <View style={wrapperStyles}>
      {minWidth.tablet ? (
        <View style={styles.chipsContainer}>{locationSearchTypePicker}</View>
      ) : null}

      <View style={searchInputWrapperStyle}>
        {searchInputType === 'search' ? (
          <LocationSearchInput {...props} />
        ) : (
          <LocationAutocompleteInput
            shouldFocusInput={isEmptyDeliverySearch}
            {...props}
          />
        )}
      </View>
    </View>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    paddingHorizontal: theme.spacing.medium,
  },
  wrapperSM: {
    paddingTop: theme.spacing.medium,
  },
  chipsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  searchInputWrapper: {
    paddingBottom: theme.spacing.small,
  },
  searchInputWrapperSM: {
    paddingTop: theme.spacing.medium,
  },
});
